import * as OrderTexts from '../../../../../../../../intl'

export const barcodesSeparator: string = ','
export const barcodeMaxLength: number = 100
export const barcodesNotAllowedCharacters = [',']

export type BarcodesValidationResult = (string | null)[]

type ValidateBarcodesOptions = {
  allowEmptyValues: boolean
}

const defaultBarcodesOptions: ValidateBarcodesOptions = {
  allowEmptyValues: false,
}

const getValidationError = (barcode: string, allowEmptyValues: boolean): string | null => {
  if (!allowEmptyValues && barcode.length === 0) {
    return OrderTexts.getBarcodesValidationText('emptyValue', barcodeMaxLength)
  }
  if (barcode.length > barcodeMaxLength) {
    return OrderTexts.getBarcodesValidationText('maxLengthViolation', barcodeMaxLength)
  }
  if (barcodesNotAllowedCharacters.some(char => barcode.includes(char))) {
    return OrderTexts.getBarcodesValidationText('notAllowedCharactersViolation', barcodeMaxLength)
  }
  return null
}

export const validateBarcodes = (
  source: string[] | string,
  options: Partial<ValidateBarcodesOptions> = {},
): BarcodesValidationResult => {
  const { allowEmptyValues } = { ...defaultBarcodesOptions, ...options }
  const barcodes = Array.isArray(source) ? source : splitBarcodes(source)

  return barcodes.map(barcode => getValidationError(barcode, allowEmptyValues))
}

export const splitBarcodes = (
  barcodes: string = '',
  separator: string = barcodesSeparator,
): string[] => {
  return barcodes
    .split(separator)
    .map(barcode => barcode.trim())
    .filter(b => b.length > 0)
}
